import React, { useEffect, useRef, useState } from 'react';
import Apple from '../../Components/Apple';
import Google from '../../Components/Google';
import SSButton from '../../Components/SSButton';
import CheckBox from '../../Components/Checkbox';
import EmailInput from '../../Components/Input/Email';
import Otp from '../../Components/Otp';
import './index.scss';
import Microsoft from '../../Components/Microsoft';
import NameInput from '../../Components/Input/NameInput';
import { postReq } from '../../utils/api';
import { getURLParameterByName } from '../../utils';

import { verifyGoogleIdToken, verifyMicrosoftIdToken } from '../../services/auth';
import { useMsal } from '@azure/msal-react';
import { InteractionRequiredAuthError, PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from '../../authConfig';
import LoadingSpin from '../../Components/LoadingSpin';
import { DOMAIN } from '../../Constants/base';
import { trackEvents } from '../../utils/analytics';
import StepProgress from '../StepProgress';

function AccountBox({ ssoProvider }) {
  const [currentStep, setCurrentStep] = useState(0);
  const [isSignUp, setIsSignUp] = useState(true);
  const [isTermsChecked, setIsTermsChecked] = useState(true);
  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [checkForValidEmail, setCheckForValidEmail] = useState(false);
  const [isApi, setIsApi] = useState(false);
  const [isBtnDisabled, setIsBtnDisabled] = useState(false);
  const [userJwtToken, setUserJwtToken] = useState(false);

  //get auth token from local storage
  const authToken = JSON.parse(localStorage.getItem('ss-auth-sales'));
  // const [authToken, setAuthToken] = useState(null);
  const appleToken = getURLParameterByName('user');
  // const microsoftToken = getURLParameterByName("client_info");
  // if (microsoftToken) {
  //   console.log(window.location.href, "ulr");
  //   debugger;
  // }

  const totalSteps = 4;

  const { instance, accounts } = useMsal();

  const [isMicrosoftLogin, setIsMicrosoftLogin] = useState(false);
  const [verifyLoader, setVerifyLoader] = useState(false);
  const apiCallingRef = useRef(null);

  useEffect(() => {
    if (currentStep === 1) {
      setIsBtnDisabled(email.length === 0);
    }
    if (currentStep === 3) {
      setIsBtnDisabled(firstName.length === 0 || lastName.length === 0);
    }
  }, [currentStep, email, firstName, lastName]);

  useEffect(() => {
    const ssoApple = async () => {
      if (appleToken) {
        if (apiCallingRef.current) return;
        apiCallingRef.current = true;
        // remove the query params from url
        setVerifyLoader(true);
        window.history.pushState({}, document.title, window.location.pathname);
        const url = `${DOMAIN}/v1/user/v2/login/sso/apple`;
        const payload = {
          authorization: appleToken,
        };
        const { code, data } = await postReq({ url, payload });
        if (code === 200) {
          if (data?.isNewUser) {
            // GTM event
            window.dataLayer.push({
              event: 'trial_registered',
              user_id: data?.id,
            });
          }
          if (data?.name) {
            const name = data.name.split(' ');
            setFirstName(name[0]);
          }
          // setAuthToken(accessToken);
          localStorage.setItem('ss-auth-sales', JSON.stringify(data.accessToken));
          window.location = '/';
        }
        if (code) {
          setVerifyLoader(false);
        }
      }
    };
    ssoApple();
  }, []);

  useEffect(() => {
    // get localStorage item
    const isStoredMSLoginFlag = JSON.parse(localStorage.getItem('isMicrosoftLogin'));

    if (accounts.length > 0 && (isMicrosoftLogin || isStoredMSLoginFlag)) {
      setVerifyLoader(true);
      const aquireToken = async () => {
        const accessTokenRequest = {
          scopes: ['user.read'],
          account: accounts[0],
        };
        const msalInstance = new PublicClientApplication(msalConfig);
        await msalInstance.initialize();
        msalInstance
          .acquireTokenSilent(accessTokenRequest)
          .then((accessTokenResponse) => {
            // Acquire token silent success
            let idToken = accessTokenResponse.idToken;
            // Call your API with token
            microsoftSsoCallback(idToken);
          })
          .catch((error) => {
            if (error instanceof InteractionRequiredAuthError) {
              instance
                .acquireTokenPopup(accessTokenRequest)
                .then(function (accessTokenResponse) {
                  // Acquire token interactive success
                  let idToken = accessTokenResponse.idToken;
                  // Call your API with token
                  microsoftSsoCallback(idToken);
                })
                .catch(function (error) {
                  // Acquire token interactive failure
                  console.log(error);
                });
            }
            console.log(error);
          });
      };
      aquireToken();
    }
  }, [accounts, isMicrosoftLogin]);

  const googleSsoCallback = async (response) => {
    const { code, data } = await verifyGoogleIdToken(response);
    if (code === 200) {
      if (data.isNewUser) {
        trackEvents('signup', { userId: data.userId });
        // GTM event
        window.dataLayer.push({
          event: 'trial_registered',
          user_id: data?.id,
        });
      } else {
        window.dataLayer.push({
          event: 'login',
          user_id: data.userId,
        });
        trackEvents('login', { userId: data.userId });
      }
      if (data?.name) {
        const name = data.name.split(' ');
        setFirstName(name[0]);
      }
      // setAuthToken(accessToken);
      localStorage.setItem('ss-auth-sales', JSON.stringify(data.accessToken));
      window.location = '/';
    }
  };

  const microsoftSsoCallback = async (response) => {
    const { code, data } = await verifyMicrosoftIdToken(response);
    if (code === 200) {
      if (data?.isNewUser) {
        // GTM event
        window.dataLayer.push({
          event: 'trial_registered',
          user_id: data?.id,
        });
      }
      if (data?.name) {
        const name = data.name.split(' ');
        setFirstName(name[0]);
      }
      // setAuthToken(accessToken);
      if (data?.accessToken) {
        localStorage.setItem('ss-auth-sales', JSON.stringify(data?.accessToken));
        window.location = '/';
      }
    }
    if (code) {
      setIsMicrosoftLogin(false);
      setVerifyLoader(false);
      // remove the flag from local storage
      localStorage.removeItem('isMicrosoftLogin');
    }
  };
  //method for handle back click event
  const handleBackClick = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }

    if (currentStep === 1 && email.length > 0) {
      setEmail('');
    }
  };

  //handle next click event
  const handleNextClick = () => {
    if (currentStep < totalSteps) {
      if (currentStep === 1 && email.length > 0 && !checkForValidEmail) {
        setCheckForValidEmail(true);
      } else if (currentStep === 3) {
        localStorage.setItem('ss-auth-sales', JSON.stringify({ accessToken: userJwtToken }));
        window.location = '/';
      }
    }
  };

  //render account box fields
  const renderAccountBoxFields = () => {
    if (currentStep === 1)
      return (
        <EmailInput
          email={email}
          setEmail={setEmail}
          checkForValidEmail={checkForValidEmail}
          setCheckForValidEmail={setCheckForValidEmail}
          setCurrentStep={setCurrentStep}
          isApi={isApi}
          setIsApi={setIsApi}
          isSignUp={isSignUp}
        />
      );
    if (currentStep === 2)
      return (
        <Otp
          email={email}
          otp={otp}
          setOtp={setOtp}
          setCurrentStep={setCurrentStep}
          setUserJwtToken={setUserJwtToken}
          isSignUp={isSignUp}
        />
      );
    if (currentStep === 3 && isSignUp)
      return (
        <NameInput firstName={firstName} setFirstName={setFirstName} lastName={lastName} setLastName={setLastName} />
      );
  };

  return (
    <>
      <>
        <div
          className="account-box-container"
          style={{
            border: verifyLoader ? 'none' : '1px solid #fff',
          }}
        >
          {
            // show loader on account-box-container
            verifyLoader && (
              <div className="account-box-container__loader">
                <LoadingSpin />
              </div>
            )
          }
          {currentStep === 0 && (
            <div
              className="flex flex-column  h-100"
              style={{
                justifyContent: 'flex-start',
              }}
            >
              <div className="header">
                <h1
                  className="sign-up-text"
                  style={{
                    borderBottom: isSignUp ? '1px solid #FFF' : '',
                  }}
                  onClick={() => {
                    setIsSignUp(true);
                    setEmail('');
                  }}
                >
                  Sign up
                </h1>
                <h1
                  className="log-in-text"
                  style={{
                    borderBottom: !isSignUp ? '1px solid #FFF' : '',
                  }}
                  onClick={() => {
                    setIsSignUp(false);
                    setEmail('');
                  }}
                >
                  Login
                </h1>
              </div>
              <h4 className="account-box-container__title">{isSignUp ? 'Create Account' : 'Access Account'}</h4>
              <div
                style={{
                  position: 'relative',
                }}
              >
                {isSignUp && (
                  <div
                    className="account-box-container__blocker"
                    style={{
                      pointerEvents: isTermsChecked ? 'none' : 'all',
                      cursor: isTermsChecked ? 'not-allowed' : 'pointer',
                    }}
                  />
                )}
                <div className="account-box-container__sso">
                  <Google successCallback={googleSsoCallback} ssoProvider={ssoProvider} />
                  <Apple />
                  <Microsoft successCallback={microsoftSsoCallback} setIsMicrosoftLogin={setIsMicrosoftLogin} />
                </div>
                <div className="account-box-container__divider">or</div>
                <div
                  className="account-box-container__email"
                  onClick={() => {
                    if (isTermsChecked) setCurrentStep(1);
                  }}
                  style={{
                    cursor: isTermsChecked ? 'pointer' : 'not-allowed',
                  }}
                >
                  continue with email
                </div>
              </div>
              {isSignUp && (
                <div className="account-box-container__check">
                  <CheckBox handleChecked={() => setIsTermsChecked(!isTermsChecked)} checked={isTermsChecked} />
                  <div
                    className="account-box-container__check-terms"
                    onClick={() => {
                      setIsTermsChecked(!isTermsChecked);
                    }}
                  >
                    Creating an account means you’re okay with our{' '}
                    <a
                      href="https://salesstack.ai/terms"
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={(e) => e.stopPropagation()}
                    >
                      Terms of Service
                    </a>{' '}
                    and{' '}
                    <a
                      href="https://salesstack.ai/privacy"
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={(e) => e.stopPropagation()}
                    >
                      Privacy Policy
                    </a>
                  </div>
                </div>
              )}
            </div>
          )}
          {currentStep !== 0 && (
            <div className="flex flex-column h-100">
              <div
                className="account-box-container__header"
                // style={{
                //   display: 'none',
                // }}
              >
                <div className="account-box-container__header-back" onClick={handleBackClick}>
                  back
                </div>
                <StepProgress currentStep={currentStep} totalSteps={isSignUp ? 3 : 2} />
              </div>
              <div className="account-box-container__form">{renderAccountBoxFields()}</div>
              <div className="account-box-container__footer">
                {/* hide continue button on otp screen */}
                {currentStep !== 2 && (
                  <SSButton
                    isDisabled={isBtnDisabled}
                    btnText={'Continue'}
                    onClickHandle={handleNextClick}
                    showLoader={isApi}
                    classBtn="btn-filled"
                  />
                )}
              </div>
            </div>
          )}
        </div>
      </>
    </>
  );
}

export default AccountBox;
